module.exports = __webpack_public_path__ + "img/login_center_bg.53078966.png";